import { formatMoney, parseMoneyInput, roundMoney } from '@/shared/format/money';

import type { MaskModel } from './caret-mask';

// Entrada "amount" do UY3.Front (money-mask.ts): os dois últimos dígitos são sempre os centavos,
// como app de banco. Nunca há estado em que o valor esteja 100× errado.
const MAX_DIGITS = 15;

function isDigit(character: string): boolean {
  return character >= '0' && character <= '9';
}

function split(significant: string) {
  const negative = significant.startsWith('-');
  return { sign: negative ? '-' : '', digits: negative ? significant.slice(1) : significant };
}

/** `'123456'` → `'1234.56'`, por manipulação de string. */
export function decimalOfDigits(digits: string): string {
  const padded = digits.padStart(3, '0');
  const integer = padded.slice(0, -2).replace(/^0+(?=\d)/, '');
  return `${integer}.${padded.slice(-2)}`;
}

export function moneyModel(locale: string, allowNegative: boolean): MaskModel {
  return {
    significant: (text) => {
      const sign = allowNegative && text.includes('-') ? '-' : '';
      const digits = Array.from(text).filter(isDigit).join('').replace(/^0+/, '').slice(0, MAX_DIGITS);
      return `${sign}${digits}`;
    },
    render: (significant) => {
      const { sign, digits } = split(significant);
      if (digits === '') return sign;
      return formatMoney(`${sign}${decimalOfDigits(digits)}`, { locale });
    },
    anchor: 'right',
  };
}

/** Lê um valor colado: pt-BR estrito primeiro, depois decimal com ponto (`1234.56`). */
export function parsePastedMoney(pasted: string): string | null {
  const strict = parseMoneyInput(pasted);
  if (strict !== null) return roundMoney(strict, { rounding: 'half-up' });
  const cleaned = pasted.replace(/R\$|\s/g, '');
  if (!/^[+-]?\d+\.\d{1,2}$/.test(cleaned)) return null;
  return roundMoney(cleaned.replace(/^\+/, ''), { rounding: 'half-up' });
}
